<template>
  <v-container
    style="max-width: 1200px; overflow: none; "
    class="d-flex flex-column"
  >
    <div
      class="d-flex mx-auto"
      style="overflow: none; width: 100%; height: 100%;"
    >
      <v-btn
        :x-small="isMobile"
        sticky
        dark
        outlined
        @click="closeGame()"
        :style="
          `left: 15px; top: -${
            isMobile ? '90' : '45'
          }px; background-color: rgba(66, 66, 66, 0.7); z-index:999999; position:sticky;`
        "
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </div>
    <div
      class="mx-auto d-flex flex-column align-center"
      style="overflow: none; width: 100%; height: 100%;"
    >
      <!-- iframe com tamanho adaptado para diferentes viewports, se no mobile, expande para a tela inteira -->
      <iframe
        v-if="gameURL.length > 0"
        allowfullscreen
        webkitallowfullscreen
        mozallowfullscreen
        :width="isMobile ? '480' : '1277'"
        :height="isMobile ? '360' : '718'"
        :style="
          `overflow: none; border: none; background-color: transparent; ${
            isMobile
              ? 'position:fixed; top:0px; bottom:0px; width:100%; height:100%; margin:0; padding:0; overflow:hidden; z-index:99999999;'
              : 'z-index: 1000;'
          }`
        "
        :src="gameURL"
      ></iframe>
      <v-progress-linear
        v-else
        indeterminate
        width="100%"
        class="mx-auto"
        style="top: 20px;"
        color="white"
      ></v-progress-linear>
    </div>
  </v-container>
</template>
<script>
import casino from "@/plugins/plugin-casino";

export default {
  name: "casino-game",
  props: ["gameID", "isFreeGame"],
  data: () => ({
    gameURL: "",
  }),
  async mounted() {
    const games = await casino.getActiveSlotGames();

    const operatorHasGame = games.find(({ id_game_provedor }) => {
      const split = id_game_provedor.split("-");
      return split[split.length - 1] === this.gameID;
    });

    if (operatorHasGame) {
      scroll(0, 0);

      if (this.isFreeGame === "true") {
        const params = `lang=${this.$store.state.language}&cur=BRL&gameSymbol=${this.gameID}&stylename=sga_sga`;
        this.gameURL = `https://demogamesfree.pragmaticplay.net/gs2c/openGame.do?${params}`;
      } else {
        this.gameURL = await casino.startGame(this.gameID);
      }
    } else {
      this.$router.push({ path: "/casino/home" });
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },
  methods: {
    closeGame() {
      this.$router.go(-1);
    },
  },
};
</script>
